export default {
  'leaderboardActivity.saving': 'Guardando...',
  'leaderboardActivity.operationSuccess': 'Operación exitosa',
  'leaderboardActivity.search': 'Buscar',
  'leaderboardActivity.reset': 'Restablecer',
  'leaderboardActivity.totalRecords': '{{total}} registros en total',

  'leaderboardActivity.listTitle': 'Lista de Actividades de Tabla de Clasificación',
  'leaderboardActivity.addActivity': 'Agregar Actividad',
  'leaderboardActivity.colName': 'Nombre de Actividad',
  'leaderboardActivity.colShowTime': 'Hora de Mostración',
  'leaderboardActivity.colEnableTime': 'Hora Efectiva',
  'leaderboardActivity.colSettle': 'Liquidación',
  'leaderboardActivity.colStatus': 'Estado',
  'leaderboardActivity.colCreateTime': 'Hora de Creación',
  'leaderboardActivity.colUpdateTime': 'Hora de Actualización',
  'leaderboardActivity.colOperator': 'Operador',
  'leaderboardActivity.colOperation': 'Acción',
  'leaderboardActivity.edit': 'Editar',
  'leaderboardActivity.copy': 'Copiar',
  'leaderboardActivity.enable': 'Habilitar',
  'leaderboardActivity.disable': 'Deshabilitar',
  'leaderboardActivity.confirmDisable': '¿Deshabilitar esta actividad?',
  'leaderboardActivity.confirmEnable': '¿Habilitar esta actividad?',
  'leaderboardActivity.statusNotStarted': 'No Iniciado',
  'leaderboardActivity.statusRunning': 'En Ejecución',
  'leaderboardActivity.statusEnded': 'Finalizado',
  'leaderboardActivity.statusDisabled': 'Deshabilitado',
  'leaderboardActivity.settleDaily': 'Diario',
  'leaderboardActivity.settleEveryNDays': 'Cada {{n}} días',

  'leaderboardActivity.addTitle': 'Agregar Actividad de Tabla de Clasificación',
  'leaderboardActivity.editTitle': 'Editar Actividad de Tabla de Clasificación',
  'leaderboardActivity.save': 'Guardar',
  'leaderboardActivity.back': 'Atrás',
  'leaderboardActivity.basicSettings': 'Básicos de Actividad',
  'leaderboardActivity.nameZh': 'Nombre de Actividad (ZH)',
  'leaderboardActivity.enterNameZh': 'Ingrese nombre de actividad (ZH)',
  'leaderboardActivity.nameEn': 'Nombre de Actividad (EN)',
  'leaderboardActivity.enterNameEn': 'Ingrese nombre de actividad (EN)',
  'leaderboardActivity.currency': 'Moneda',
  'leaderboardActivity.selectCurrency': 'Seleccionar moneda',
  'leaderboardActivity.showTime': 'Hora de Mostración',
  'leaderboardActivity.selectShowTime': 'Seleccionar hora de mostración',
  'leaderboardActivity.enableTime': 'Hora Efectiva',
  'leaderboardActivity.selectEnableTime': 'Seleccionar hora efectiva',

  'leaderboardActivity.boardRecordsTitle': 'Resultados de Liquidación',
  'leaderboardActivity.all': 'Todos',
  'leaderboardActivity.export': 'Exportar',
  'leaderboardActivity.operationFail': 'Operación fallida',
  'leaderboardActivity.colActivity': 'Actividad',
  'leaderboardActivity.colBoard': 'Tabla',
  'leaderboardActivity.colBoardName': 'Nombre de Tabla',
  'leaderboardActivity.colPeriod': 'Período',
  'leaderboardActivity.colRank': 'Rango',
  'leaderboardActivity.colUserAccount': 'Cuenta de Miembro',
  'leaderboardActivity.colMetricValue': 'Valor Métrico',
  'leaderboardActivity.colSnapshotTime': 'Hora de Captura',
  'leaderboardActivity.filterActivityDate': 'Fecha de Actividad',
  'leaderboardActivity.colVip': 'Nivel VIP',
  'leaderboardActivity.selectVip': 'Seleccionar nivel VIP',
  'leaderboardActivity.colCoin': 'Moneda',
  'leaderboardActivity.colSettleDate': 'Fecha de Liquidación',
  'leaderboardActivity.colYesterdayBet': 'Apuesta Válida de Ayer',
  'leaderboardActivity.colTodayBet': 'Apuesta Válida de Hoy',
  'leaderboardActivity.colBetCount': 'Cantidad de Apuestas',
  'leaderboardActivity.colProfitRate': 'Tasa de Ganancia',
  'leaderboardActivity.colLastBetTime': 'Última Hora de Apuesta',
  'leaderboardActivity.colRewardDue': 'Recompensa Vencida',
  'leaderboardActivity.colAwardStatus': 'Estado de Otorgamiento',
  'leaderboardActivity.rewardTypeCash': 'Efectivo',
  'leaderboardActivity.rewardTypePoint': 'Puntos',
  'leaderboardActivity.rewardTypeSpin': 'Boleto de Giro',
  'leaderboardActivity.awardPendingConfirm': 'Confirmación Pendiente',
  'leaderboardActivity.awardPendingGrant': 'Otorgamiento Pendiente',
  'leaderboardActivity.awardGranted': 'Otorgado',
  'leaderboardActivity.awardRejected': 'Rechazado',
  'leaderboardActivity.actionConfirm': 'Confirmar Otorgamiento',
  'leaderboardActivity.actionReject': 'Rechazar',
  'leaderboardActivity.batchConfirm': 'Otorgamiento de Confirmación de Lote',
  'leaderboardActivity.confirmGrantTip': '¿Confirmar otorgamiento para registros seleccionados? Se moverán a Otorgamiento Pendiente y serán pagados por el lote de las 16:00.',
  'leaderboardActivity.rejectTip': '¿Rechazar registros seleccionados? No serán otorgados.',
  'leaderboardActivity.noSelection': 'Por favor seleccionar registros primero',
  'leaderboardActivity.grantSuccess': 'Éxito, {{n}} registro(s)',

  'leaderboardActivity.awardRecordsTitle': 'Registros de Premios',
  'leaderboardActivity.colRewardType': 'Tipo de Recompensa',
  'leaderboardActivity.colRewardValue': 'Valor de Recompensa',
  'leaderboardActivity.colGrantStatus': 'Estado de Otorgamiento',
  'leaderboardActivity.colGrantTime': 'Hora de Otorgamiento',
  'leaderboardActivity.grantPending': 'Pendiente',
  'leaderboardActivity.grantGranted': 'Otorgado',
  'leaderboardActivity.grantFailed': 'Fallido',
  'leaderboardActivity.colRejectReason': 'Razón de Rechazo',
};
